import { render, staticRenderFns } from "./miniIndex.vue?vue&type=template&id=39873118&scoped=true&"
import script from "./miniIndex.vue?vue&type=script&lang=js&"
export * from "./miniIndex.vue?vue&type=script&lang=js&"
import style0 from "./miniIndex.vue?vue&type=style&index=0&id=39873118&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39873118",
  null
  
)

export default component.exports